<template>
  <div class="careers">
    <Header />

    <main role="main">
      <CareersTeam />
      <div class="careers__background-wrapper">
        <div class="careers__background-grain" />
        <CareersBenefits />
        <CareersCulture />
      </div>
      <CareersSchedule />
      <AboutUsMap />
      <CareersInBravado />
    </main>

    <Footer />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import AOS from 'aos';
import CareersTeam from './page-sections/CareersTeam.vue';
import CareersBenefits from './page-sections/CareersBenefits.vue';
import CareersCulture from './page-sections/CareersCulture.vue';
import CareersSchedule from './page-sections/CareersSchedule.vue';
import CareersInBravado from './page-sections/CareersInBravado.vue';
import AboutUsMap from '~/components/partials/landings/about-us/page-sections/AboutUsMap.vue';
import Footer from '~/components/global/Footer/Footer.vue';
import Header from '~/components/global/Header/Header.vue';

import 'aos/dist/aos.css';

export default Vue.extend({
  name: 'Careers',
  components: {
    Header,
    Footer,
    CareersTeam,
    CareersBenefits,
    CareersCulture,
    CareersSchedule,
    AboutUsMap,
    CareersInBravado,
  },
  mounted() {
    AOS.init();
  },
});
</script>

<style lang="scss" scoped>
.careers {
  //min-height: 100vh;

  background: var(--theme-color-card);

  &__background-wrapper {
    background-repeat: no-repeat;
    background-position: center top;
    background-image: url('~@/components/partials/landings/careers/images/bg/benefits-bg.webp');
    background-size: cover;
    position: relative;
  }

  &__background-grain {
    background-image: url('@/components/partials/landings/careers/images/bg/grain.png');
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    mix-blend-mode: soft-light;
  }
}
</style>
